import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('modules.AddonsWarningBanner', {
    warning:
        "We've temporarily paused your usage of {addonTitle} at {subscriptionCodes} due to unusual activity. To unlock your access and continue using our services, please contact us.",
    addonCaptureTitle: 'ApprovalMax Capture',
    addonPayTitle: 'ApprovalMax Pay',
    contactUsText: 'Contact support',
});
